import request from '../utils/request';
import qs from "qs";

export function getCleanerList(param) {
    return request({
        url: '/admin/search-cleaner',
        method: 'GET',
        params: param
    })
}

export function getAllCleaner() {
    return request({
        url: '/admin/all-cleaner',
        method: 'GET'
    })
}
export function saveCleaner(id, data) {
    if (id > 0) {
        return request({
            url: '/admin/cleaner/'+id,
            method: 'PUT',
            data
        })
    } else {
        return request({
            url: '/admin/cleaner',
            method: 'POST',
            data
        })
    }

}

export function deleteCleaner(id) {
    return request({
        url: '/admin/cleaner/' + id,
        method: 'DELETE'
    })
}

export function setCleanerIsValidate(id, value) {
    return request({
        url: '/admin/cleaner/' + id + '/is-validate/'+ value,
        method: 'PUT',
    })
}

export function bindCleaner(id,data) {
    return request({
        url: '/admin/store/'+id+'/cleaner',
        method: 'PUT',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({"ids":data.ids})
    })
}
export function getStoreCleaner(id) {
    return request({
        url: '/admin/store/'+id+'/cleaners',
        method: 'GET'
    })
}

export function getCleanerStore(id) {
    return request({
        url: '/admin/cleaner/'+id+'/stores',
        method: 'GET'
    })
}

export function bindStore(id,data) {
    return request({
        url: '/admin/cleaner/'+id+'/store',
        method: 'PUT',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({"ids":data.ids})
    })
}

export function setCleanerPass(pass, id) {
    return request({
        url: '/admin/cleaner/'+id+'/password',
        method: 'PUT',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({"password":pass})
    })
}